import { ReferentialKey } from 'api/referential';
import { toDayInput } from 'core/utils/dates';
import { ComponentKey } from 'enums/componentKey';
import { InputsConfig } from 'types/form/inputsConfig';
import { QuoteMandateFormFieldNames } from './quoteMandateForm';

export const quoteMandateInputsConfig: InputsConfig<QuoteMandateFormFieldNames> =
  {
    [QuoteMandateFormFieldNames.StartDate]: {
      componentKey: ComponentKey.InputText,
      name: QuoteMandateFormFieldNames.StartDate,
      type: 'date',
      required: true,
      // Miroir de la règle back (UpdateDevisMandatAsync) : pas de date de début dans le passé.
      min: toDayInput(new Date()),
      label: 'QUOTE_MANDATE_FORM.LABELS.START_DATE'
    },
    [QuoteMandateFormFieldNames.Frequency]: {
      componentKey: ComponentKey.ReferentialDropdown,
      referentialKey: ReferentialKey.MandateFrequency,
      name: QuoteMandateFormFieldNames.Frequency,
      label: 'QUOTE_MANDATE_FORM.LABELS.FREQUENCY',
      required: true,
      // Miroir de la règle back (UpdateDevisMandatAsync) : pour un aliment,
      // la périodicité est imposée par le contrat collectif, pas de choix.
      disabled: (state) => !!state?.isGroupContract
    },
    [QuoteMandateFormFieldNames.DueDate]: {
      name: QuoteMandateFormFieldNames.DueDate,
      componentKey: ComponentKey.Custom
    },
    // Rendu directement par le layout (radio + message), pas par la factory.
    [QuoteMandateFormFieldNames.Payer]: {
      name: QuoteMandateFormFieldNames.Payer,
      componentKey: ComponentKey.Custom
    },
    [QuoteMandateFormFieldNames.BankAccount]: {
      componentKey: ComponentKey.BankAccountSelector,
      name: QuoteMandateFormFieldNames.BankAccount,
      items: []
    }
  };
